import { getAverageRatingMergedAction } from 'commerce/services/reviews/actions';
import {
  AverageRatingResponse,
  IProductForAverageReviews,
  IProductWithRefKeys,
} from './types';

export const addAverageRatingToProducts = ({
  products,
  rating,
}: {
  products?: IProductForAverageReviews[];
  rating?: AverageRatingResponse;
}): IProductForAverageReviews[] => {
  if (!products?.length) {
    return [];
  }
  if (!rating) {
    return products;
  }

  return products.map((product) => ({
    ...product,
    ratingCount: rating?.[product.id]?.count || 0,
    ratingScore: rating?.[product.id]?.rating || 0,
  }));
};

export const createProductsWithRefKeys = (
  products: IProductForAverageReviews[],
) => {
  return (
    products.map<IProductWithRefKeys>((product) => ({
      productId: product.id,
      referenceKeys: getReferenceKeys(product),
    })) || []
  );
};

export const getReferenceKeys = (
  product: IProductForAverageReviews,
): string[] => {
  return [
    product.referenceKey,
    ...(product?.siblings?.map(({ referenceKey }) => referenceKey) || []),
  ];
};

export const getAverageRatingForProducts = async (
  entities: IProductForAverageReviews[],
  getAverageRating = getAverageRatingMergedAction,
): Promise<AverageRatingResponse> => {
  const products = createProductsWithRefKeys(entities);

  try {
    const responses = await Promise.all(
      products.map(({ referenceKeys }) =>
        getAverageRating({ productReferenceKeys: referenceKeys }).catch(() => {
          return null; // Return null or a default value if there’s an error
        }),
      ),
    );

    return responses.reduce<AverageRatingResponse>((acc, item, index) => {
      if (item) {
        acc[products[index].productId] = {
          rating: item.response?.data.avgRating,
          count: item.response?.data.totalCount,
        };
      }
      return acc;
    }, {});
  } catch (error) {
    console.error(error);
    return {};
  }
};
